import { create } from 'zustand'
import { IProfiles } from 'services/user'

export type TSetStoreAction<T> = (prevState: T) => void

type TRolesStore = {
  roles: string[]
  brandAdm: boolean
  brandConsultant: boolean
  brandAssociate: boolean
  profiles: IProfiles[]
  setRoles: TSetStoreAction<string[]>
  setIsBrandAdm: TSetStoreAction<boolean>
  setIsBrandConsultant: TSetStoreAction<boolean>
  setBrandAssociate: TSetStoreAction<boolean>
  setInitialStore: () => void
  setProfiles: TSetStoreAction<IProfiles[]>
}

export const getRolesStore = (store: TRolesStore) => ({
  roles: store.roles,
})
export const getBranAdmStore = (store: TRolesStore) => ({
  brandAdm: store.brandAdm,
})
export const getBrandConsultantStore = (store: TRolesStore) => ({
  brandConsultant: store.brandConsultant,
})
export const getBrandAssociateStore = (store: TRolesStore) => ({
  brandAssociate: store.brandAssociate,
})
export const getProfilesStore = (store: TRolesStore) => ({
  profiles: store.profiles,
})

const INITIAL_STORE = {
  roles: [],
  brandAdm: false,
  brandConsultant: false,
  brandAssociate: false,
  profiles: [],
}

export const useRolesStore = create<TRolesStore>(set => ({
  ...INITIAL_STORE,
  setRoles: (roles: string[]) => set({ roles }),
  setInitialStore: () => set(INITIAL_STORE),
  setIsBrandAdm: (brandAdm: boolean) => set({ brandAdm }),
  setIsBrandConsultant: (brandConsultant: boolean) => set({ brandConsultant }),
  setBrandAssociate: (brandAssociate: boolean) => set({ brandAssociate }),
  setProfiles: (profiles: IProfiles[]) => set({ profiles }),
}))
